import { useState } from "react";
import { useI18n } from "../../../i18n/I18nContext";
import Footer from "../Footer/Footer";

export default function PressReleases() {
  const { t } = useI18n();

  const comunicados = [
  {
    id: 1,
    categoria: t("Produto"),
    titulo: t("RacksForAll lança nova linha de estantes porta-paletes reforçadas"),
    resumo:
      t("A RacksForAll apresenta a sua mais recente linha de estantes porta-paletes, desenvolvidas para suportar cargas até 6 toneladas por nível, com certificação europeia de segurança."),
    data: "2026-03-15",
    destaque: true,
  },
  {
    id: 2,
    categoria: t("Parceria"),
    titulo: t("RacksForAll e Logistics WMS anunciam parceria estratégica"),
    resumo:
      t("A parceria entre a RacksForAll e a Logistics WMS permite oferecer aos clientes uma solução integrada de armazenamento físico e gestão de armazém numa única proposta."),
    data: "2026-02-28",
    destaque: false,
  },
  {
    id: 3,
    categoria: t("Empresa"),
    titulo: t("RacksForAll expande operações para o mercado espanhol"),
    resumo:
      t("Com a abertura de um novo escritório em Madrid, a RacksForAll reforça a sua presença no mercado ibérico e europeu, servindo agora clientes em mais de 8 países."),
    data: "2026-02-10",
    destaque: false,
  },
  {
    id: 4,
    categoria: t("Certificação"),
    titulo: t("Renovação da certificação ISO 9001:2015"),
    resumo:
      t("A RacksForAll renovou com sucesso a certificação ISO 9001:2015, reafirmando o compromisso com os mais altos padrões de qualidade nos processos de fabrico e serviço ao cliente."),
    data: "2026-01-20",
    destaque: false,
  },
  {
    id: 5,
    categoria: t("Evento"),
    titulo: t("RacksForAll presente na feira LogiMAT 2026"),
    resumo:
      t("A RacksForAll marcou presença na LogiMAT 2026 em Estugarda, apresentando as suas soluções de armazenamento e estabelecendo novos contactos com parceiros europeus."),
    data: "2025-12-05",
    destaque: false,
  },
  {
    id: 6,
    categoria: t("Produto"),
    titulo: t("Nova solução de estantes cantilever para cargas longas"),
    resumo:
      t("Ideal para tubos, perfis e madeira, a nova gama cantilever da RacksForAll oferece flexibilidade máxima com braços ajustáveis e estrutura galvanizada de longa duração."),
    data: "2025-11-18",
    destaque: false,
  },
];

const categorias = [t("Todos"), t("Produto"), t("Parceria"), t("Empresa"), t("Certificação"), t("Evento")];

const categoriaBadgeClass = {
  [t("Produto")]: "bg-indigo-50 text-indigo-600",
  [t("Parceria")]: "bg-purple-50 text-purple-600",
[t("Empresa")]: "bg-blue-50 text-blue-600",
  [t("Certificação")]: "bg-green-50 text-green-600",
  [t("Evento")]: "bg-orange-50 text-orange-600",
};

  const [categoriaAtiva, setCategoriaAtiva] = useState(t("Todos"));
  const [expandido, setExpandido] = useState(null);

  const filtrados =
    categoriaAtiva === t("Todos")
      ? comunicados
      : comunicados.filter((c) => c.categoria === categoriaAtiva);

  const destaque = comunicados.find((c) => c.destaque);
  const resto = filtrados.filter((c) => !c.destaque || categoriaAtiva !== t("Todos"));

  return (
    <div className="min-h-screen bg-white flex flex-col">

      {/* Hero */}
      <section className="bg-indigo-700 pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 lg:py-20 text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-4 bg-white/10 px-3 py-1 rounded-full">
            {t("Sala de Imprensa")}
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            {t("Comunicados")}
          </h1>
          <p className="text-indigo-100/80 max-w-xl mx-auto text-base">
            {t("Acompanhe as últimas novidades, anúncios e comunicados oficiais da RacksForAll.")}
          </p>
        </div>
        <div className="overflow-hidden leading-none">
          <svg viewBox="0 0 1440 60" className="w-full" preserveAspectRatio="none" style={{ height: 60 }}>
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="white" />
          </svg>
        </div>
      </section>

      <section className="py-20 bg-white flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">

          {/* Destaque */}
          {categoriaAtiva === t("Todos") && destaque && (
            <div className="rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden mb-10">
              <div className="bg-indigo-600 px-8 py-6 flex items-center justify-between">
                <div>
                  <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-1">
                    {t("Destaque")}
                  </span>
                  <h2 className="text-xl sm:text-2xl font-bold text-white">{destaque.titulo}</h2>
                </div>
                <span className="hidden sm:inline-block text-xs font-semibold bg-white/20 text-white px-3 py-1 rounded-full">
                  {destaque.categoria}
                </span>
              </div>
              <div className="px-8 py-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                <p className="text-sm text-gray-500 leading-relaxed max-w-2xl">{destaque.resumo}</p>
                <div className="shrink-0 text-xs text-gray-400 whitespace-nowrap">
                  {new Date(destaque.data).toLocaleDateString("pt-PT", {
                    day: "numeric", month: "long", year: "numeric",
                  })}
                </div>
              </div>
            </div>
          )}

          {/* Filtros */}
          <div className="flex flex-wrap gap-2 mb-8">
            {categorias.map((cat) => (
              <button
                key={cat}
                onClick={() => setCategoriaAtiva(cat)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
                  categoriaAtiva === cat
                    ? "bg-indigo-600 text-white shadow-sm"
                    : "border border-gray-200 text-gray-600 hover:bg-gray-50"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Lista */}
          <div className="space-y-4">
            {resto.map((c) => (
              <div
                key={c.id}
                className="rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden hover:shadow-lg transition-all"
              >
                <button
                  onClick={() => setExpandido(expandido === c.id ? null : c.id)}
                  className="w-full text-left px-6 py-5 flex items-start sm:items-center justify-between gap-4"
                >
                  <div className="flex items-start sm:items-center gap-4 flex-1 min-w-0">
                    <span className={`shrink-0 inline-block text-xs font-semibold px-2.5 py-1 rounded-full ${categoriaBadgeClass[c.categoria] || "bg-gray-100 text-gray-600"}`}>
                      {c.categoria}
                    </span>
                    <p className="font-semibold text-gray-900 text-sm sm:text-base truncate">{c.titulo}</p>
                  </div>
                  <div className="flex items-center gap-4 shrink-0">
                    <span className="hidden sm:block text-xs text-gray-400 whitespace-nowrap">
                      {new Date(c.data).toLocaleDateString("pt-PT", {
                        day: "numeric", month: "short", year: "numeric",
                      })}
                    </span>
                    <svg
                      className={`w-4 h-4 text-gray-400 transition-transform ${expandido === c.id ? "rotate-180" : ""}`}
                      fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>

                {expandido === c.id && (
                  <div className="px-6 pb-5 border-t border-gray-100">
                    <p className="text-sm text-gray-500 leading-relaxed pt-4">{c.resumo}</p>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-xs text-gray-400">
                        {new Date(c.data).toLocaleDateString("pt-PT", {
                          day: "numeric", month: "long", year: "numeric",
                        })}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ))}

            {resto.length === 0 && (
              <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400 rounded-3xl border border-dashed border-gray-200">
                <p className="text-sm">{t("Nenhum comunicado nesta categoria.")}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}